// import React, { useState, useRef, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useWorkouts } from "../../hooks/Workout/useWorkouts";
// import { ArrowLeft, Clock, Play, X, Lock } from "lucide-react";
// import { getFullUrl, MEDIA_BASE_URL } from "../../Utils/Workout/mediaUtils";

// // ─── Subscription helper ───────────────────────────────────────────────────
// const hasActiveSubscription = () => {
//   try {
//     const raw = localStorage.getItem("userSubscription");
//     if (!raw) return false;
//     const sub = JSON.parse(raw);
//     if (sub?.status !== "Active") return false;
//     if (!sub?.expiryDate) return false;
//     return new Date(sub.expiryDate) > new Date();
//   } catch {
//     return false;
//   }
// };
// // ──────────────────────────────────────────────────────────────────────────

// const WorkoutDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [isPlaying, setIsPlaying] = useState(false);
//   const [activeEpisode, setActiveEpisode] = useState(null);
//   const [videoStartTime, setVideoStartTime] = useState(null);
//   const [isVideoEnded, setIsVideoEnded] = useState(false);
//   const videoRef = useRef(null);
//   const timerRef = useRef(null);

//   const { data: workouts = [], isLoading, isError } = useWorkouts();

//   const getBestMedia = (media = []) => {
//     if (!media || media.length === 0) return null;
//     return (
//       media.find((m) => m.status === "ready") || media[media.length - 1] || null
//     );
//   };

//   // Get current workout and episodes
//   const workout = workouts.find((w) => w._id === id);
//   const categoryId = workout?.categoryId?._id;

//   const episodes = workouts
//     .filter((w) => w.categoryId?._id === categoryId)
//     .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));

//   const currentEpisode = activeEpisode || workout;
//   const currentMedia = getBestMedia(currentEpisode?.media);
//   const isPreviewOnly =
//     !hasActiveSubscription() && currentMedia?.isFree === false;

//   // ── FIX: Auto-play immediately when play button is clicked ───────────────
//   useEffect(() => {
//     if (isPlaying && videoRef.current) {
//       const playTimer = setTimeout(() => {
//         if (videoRef.current) {
//           videoRef.current.play().catch(() => {});
//         }
//       }, 50);
//       return () => clearTimeout(playTimer);
//     }
//   }, [isPlaying, currentEpisode]);
//   // ────────────────────────────────────────────────────────────────────────

//   // Timer effect for 90-second redirect (only when preview-only)
//   useEffect(() => {
//     if (isPlaying && videoStartTime && isPreviewOnly && !isVideoEnded) {
//       clearTimeout(timerRef.current);

//       const elapsedSeconds = (Date.now() - videoStartTime) / 1000;
//       const remainingSeconds = Math.max(0, 90 - elapsedSeconds);

//       if (remainingSeconds <= 0) {
//         handleCloseVideo();
//         navigate("/plan");
//       } else {
//         timerRef.current = setTimeout(() => {
//           handleCloseVideo();
//           navigate("/plan");
//         }, remainingSeconds * 1000);
//       }
//     } else {
//       clearTimeout(timerRef.current);
//     }

//     return () => clearTimeout(timerRef.current);
//   }, [isPlaying, videoStartTime, isPreviewOnly, navigate, isVideoEnded]);

//   // Cleanup timer on component unmount
//   useEffect(() => {
//     return () => {
//       if (timerRef.current) {
//         clearTimeout(timerRef.current);
//       }
//     };
//   }, []);

//   const handlePlayNow = () => {
//     if (videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.currentTime = 0;
//     }
//     setIsVideoEnded(false);
//     setActiveEpisode(null);
//     setVideoStartTime(Date.now());
//     setIsPlaying(true);
//   };

//   const handleEpisodePlay = (episode) => {
//     if (videoRef.current && isPlaying) {
//       videoRef.current.pause();
//       videoRef.current.currentTime = 0;
//     }

//     if (timerRef.current) {
//       clearTimeout(timerRef.current);
//     }

//     setIsVideoEnded(false);
//     setActiveEpisode(episode);
//     setVideoStartTime(Date.now());
//     setIsPlaying(true);

//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handleCloseVideo = () => {
//     if (videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.currentTime = 0;
//     }
//     setIsPlaying(false);
//     setActiveEpisode(null);
//     setVideoStartTime(null);
//     setIsVideoEnded(false);
//     clearTimeout(timerRef.current);
//   };

//   const handleVideoEnded = () => {
//     setIsVideoEnded(true);
//     setIsPlaying(false);
//     setVideoStartTime(null);
//     clearTimeout(timerRef.current);

//     if (videoRef.current) {
//       videoRef.current.currentTime = 0;
//     }
//   };

//   const handleVideoTimeUpdate = () => {
//     if (videoRef.current && isPreviewOnly && !isVideoEnded) {
//       const currentTime = videoRef.current.currentTime;
//       if (currentTime >= 90) {
//         handleCloseVideo();
//         navigate("/plan");
//       }
//     }
//   };

//   if (isLoading) {
//     return (
//       <div className="bg-white flex items-center justify-center min-h-screen">
//         <div className="text-center">
//           <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-lime-400" />
//           <p className="mt-4 text-gray-400">Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   if (isError || !workout) {
//     return (
//       <div className="bg-white flex items-center justify-center min-h-screen">
//         <div className="text-center">
//           <p className="text-gray-800 text-lg font-semibold mb-4">
//             {isError ? "Something went wrong." : "Workout not found."}
//           </p>
//           <button
//             onClick={() => navigate(-1)}
//             className="px-5 py-2 rounded-full font-bold text-black bg-lime-400 hover:bg-lime-500 transition"
//           >
//             Go Back
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const resolvedMedia = getBestMedia(currentEpisode?.media);
//   const currentVideoUrl = resolvedMedia?.url
//     ? getFullUrl(resolvedMedia.url)
//     : null;
//   const currentThumbnail = resolvedMedia?.thumbnailUrl
//     ? getFullUrl(resolvedMedia.thumbnailUrl)
//     : currentEpisode?.img
//     ? `${MEDIA_BASE_URL}/uploads/workout/${currentEpisode.img}`
//     : null;

//   return (
//     <div
//       className="bg-white text-gray-800 min-h-screen"
//       style={{ fontFamily: "'Segoe UI', sans-serif" }}
//     >
//       {/* ── Hero (original layout restored) ── */}
//       <div
//         className="relative w-full bg-gray-100"
//         style={{ paddingTop: "56.25%" }}
//       >
//         {!isPlaying ? (
//           <>
//             {/* Back Button */}
//             <button
//               onClick={() => navigate("/dashboard")}
//               className="absolute top-4 left-4 z-20 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm shadow-md flex items-center justify-center hover:bg-white transition-colors"
//               aria-label="Go back"
//             >
//               <ArrowLeft className="w-5 h-5 text-gray-700" />
//             </button>

//             {/* Thumbnail */}
//             {currentThumbnail ? (
//               <img
//                 src={currentThumbnail}
//                 alt={workout.title || categoryId}
//                 className="absolute inset-0 w-full h-full object-cover"
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.style.display = "none";
//                 }}
//               />
//             ) : (
//               <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
//                 <span className="text-gray-500 text-sm">No preview</span>
//               </div>
//             )}

//             {/* Play Button */}
//             <div className="absolute inset-0 flex items-center justify-center z-10">
//               <button
//                 onClick={handlePlayNow}
//                 className="w-14 h-14 rounded-full flex items-center justify-center bg-black/60 backdrop-blur-sm border border-white/20 shadow-md transition-transform active:scale-95 hover:scale-105"
//                 aria-label="Play video"
//               >
//                 <Play className="w-6 h-6 text-white fill-white ml-1" />
//               </button>
//             </div>

//             {/* Duration Icon */}
//             <div className="absolute bottom-4 right-4 z-10 w-12 h-12 rounded-xl bg-white/90 shadow-lg flex items-center justify-center">
//               <Clock className="w-6 h-6 text-gray-600" />
//             </div>
//           </>
//         ) : (
//           <div className="absolute inset-0 bg-black flex items-center justify-center">
//             <video
//               ref={videoRef}
//               controls

//               className="w-full h-full object-contain"
//               poster={currentThumbnail || undefined}
//               onEnded={handleVideoEnded}
//               onTimeUpdate={handleVideoTimeUpdate}
//               onPlay={() => {
//                 if (!videoStartTime) {
//                   setVideoStartTime(Date.now());
//                 }
//               }}
//               key={currentVideoUrl}
//             >
//               <source src={currentVideoUrl} type="application/x-mpegURL" />
//               {currentVideoUrl?.endsWith(".m3u8") && (
//                 <source
//                   src={currentVideoUrl.replace(".m3u8", ".mp4")}
//                   type="video/mp4"
//                 />
//               )}
//             </video>
//             <button
//               onClick={handleCloseVideo}
//               className="absolute top-3 left-3 z-20 w-9 h-9 rounded-full bg-black/60 flex items-center justify-center hover:bg-black/80 transition-colors"
//               aria-label="Close video"
//             >
//               <X className="w-4 h-4 text-white" />
//             </button>
//           </div>
//         )}
//       </div>

//       {/* ── Play Now Button (only when video is closed) ── */}
//       {!isPlaying && !isVideoEnded && (
//         <div className="px-5 pt-5 pb-2">
//           <button
//             onClick={handlePlayNow}
//             className="flex items-center gap-2 px-6 py-3 rounded-full font-bold text-black text-base shadow-md transition-transform active:scale-95 hover:brightness-105 bg-lime-400"
//           >
//             Play Now
//             <span className="w-7 h-7 rounded-full border-2 border-black flex items-center justify-center">
//               <svg
//                 className="w-4 h-4 ml-0.5"
//                 fill="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path d="M8 5v14l11-7z" />
//               </svg>
//             </span>
//           </button>
//         </div>
//       )}

//       {/* ── Episodes List ── */}
//       <div className="px-5 pt-4 pb-10 mb-16 sm:mb-0">
//         <h2 className="text-gray-800 text-2xl font-bold mb-5">Episodes</h2>
//         <div className="flex flex-col gap-3">
//           {episodes.map((episode, idx) => {
//             const epMedia = getBestMedia(episode?.media);
//             const epThumbnail = epMedia?.thumbnailUrl
//               ? getFullUrl(epMedia.thumbnailUrl)
//               : episode?.img
//               ? `${MEDIA_BASE_URL}/uploads/workout/${episode.img}`
//               : null;
//             const isCurrentRoute =
//               (episode._id === id && !activeEpisode) ||
//               activeEpisode?._id === episode._id;
//             const epTitle =
//               episode.title || epMedia?.originalName || `Episode ${idx + 1}`;
//             const epIsPreviewOnly =
//               !hasActiveSubscription() && epMedia?.isFree === false;

//             return (
//               <div
//                 key={episode._id}
//                 onClick={() => {
//                   if (isPlaying) handleCloseVideo();
//                   navigate(`/workout/${episode._id}`, { replace: true });
//                 }}
//                 className={`flex items-center gap-3 rounded-2xl p-3 cursor-pointer transition-all ${
//                   isCurrentRoute
//                     ? "bg-lime-50 border border-lime-200"
//                     : "bg-gray-50 border border-gray-100 hover:bg-gray-100"
//                 }`}
//               >
//                 <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 bg-gray-100 relative">
//                   {epThumbnail ? (
//                     <img
//                       src={epThumbnail}
//                       alt={epTitle}
//                       className="w-full h-full object-cover"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.style.display = "none";
//                       }}
//                     />
//                   ) : (
//                     <div className="w-full h-full bg-gray-200 flex items-center justify-center">
//                       <Play className="w-6 h-6 text-gray-400" />
//                     </div>
//                   )}
//                 </div>

//                 <div className="flex-1 min-w-0">
//                   <p className="text-gray-800 text-sm font-semibold truncate">
//                     {epTitle}
//                   </p>
//                   {episode.sequence && (
//                     <p className="text-gray-500 text-xs mt-0.5">
//                       Episode {episode.sequence}
//                     </p>
//                   )}
//                 </div>

//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleEpisodePlay(episode);
//                   }}
//                   className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 shadow-md transition-transform active:scale-90 hover:brightness-105 bg-lime-400"
//                   aria-label={`Play ${epTitle}`}
//                 >
//                   <Play className="w-4 h-4 text-black ml-0.5 fill-black" />
//                 </button>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WorkoutDetail;


import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useWorkouts } from "../../hooks/Workout/useWorkouts";
import { ArrowLeft, Clock, Play, X, Lock } from "lucide-react";
import { getFullUrl, MEDIA_BASE_URL } from "../../Utils/Workout/mediaUtils";

// ─── Subscription helper ───────────────────────────────────────────────────
const hasActiveSubscription = () => {
  try {
    const raw = localStorage.getItem("userSubscription");
    if (!raw) return false;
    const sub = JSON.parse(raw);
    if (sub?.status !== "Active") return false;
    if (!sub?.expiryDate) return false;
    return new Date(sub.expiryDate) > new Date();
  } catch {
    return false;
  }
};
// ──────────────────────────────────────────────────────────────────────────

const WorkoutDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isPlaying, setIsPlaying] = useState(false);
  const [activeEpisode, setActiveEpisode] = useState(null);
  const [videoStartTime, setVideoStartTime] = useState(null);
  const [isVideoEnded, setIsVideoEnded] = useState(false);
  const videoRef = useRef(null);
  const timerRef = useRef(null);

  const { data: workouts = [], isLoading, isError } = useWorkouts();

  const getBestMedia = (media = []) => {
    if (!media || media.length === 0) return null;
    return (
      media.find((m) => m.status === "ready") || media[media.length - 1] || null
    );
  };

  const workout = workouts.find((w) => w._id === id);
  const categoryId = workout?.categoryId?._id;

  const episodes = workouts
    .filter((w) => w.categoryId?._id === categoryId)
    .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));

  const currentEpisode = activeEpisode || workout;
  const currentMedia = getBestMedia(currentEpisode?.media);
  const isPreviewOnly =
    !hasActiveSubscription() && currentMedia?.isFree === false;

  useEffect(() => {
    if (isPlaying && videoRef.current) {
      const playTimer = setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.play().catch(() => {});
        }
      }, 50);
      return () => clearTimeout(playTimer);
    }
  }, [isPlaying, currentEpisode]);

  useEffect(() => {
    if (isPlaying && videoStartTime && isPreviewOnly && !isVideoEnded) {
      clearTimeout(timerRef.current);
      const elapsedSeconds = (Date.now() - videoStartTime) / 1000;
      const remainingSeconds = Math.max(0, 90 - elapsedSeconds);
      if (remainingSeconds <= 0) {
        handleCloseVideo();
        navigate("/plan");
      } else {
        timerRef.current = setTimeout(() => {
          handleCloseVideo();
          navigate("/plan");
        }, remainingSeconds * 1000);
      }
    } else {
      clearTimeout(timerRef.current);
    }
    return () => clearTimeout(timerRef.current);
  }, [isPlaying, videoStartTime, isPreviewOnly, navigate, isVideoEnded]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const handlePlayNow = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setIsVideoEnded(false);
    setActiveEpisode(null);
    setVideoStartTime(Date.now());
    setIsPlaying(true);
  };

  const handleEpisodePlay = (episode) => {
    if (videoRef.current && isPlaying) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    setIsVideoEnded(false);
    setActiveEpisode(episode);
    setVideoStartTime(Date.now());
    setIsPlaying(true);
  };

  const handleCloseVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setIsPlaying(false);
    setActiveEpisode(null);
    setVideoStartTime(null);
    setIsVideoEnded(false);
    clearTimeout(timerRef.current);
  };

  const handleVideoEnded = () => {
    setIsVideoEnded(true);
    setIsPlaying(false);
    setVideoStartTime(null);
    clearTimeout(timerRef.current);
    if (videoRef.current) videoRef.current.currentTime = 0;
  };

  const handleVideoTimeUpdate = () => {
    if (videoRef.current && isPreviewOnly && !isVideoEnded) {
      if (videoRef.current.currentTime >= 90) {
        handleCloseVideo();
        navigate("/plan");
      }
    }
  };

  if (isLoading) {
    return (
      <div className="bg-white flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-lime-400" />
          <p className="mt-4 text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (isError || !workout) {
    return (
      <div className="bg-white flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-gray-800 text-lg font-semibold mb-4">
            {isError ? "Something went wrong." : "Workout not found."}
          </p>
          <button
            onClick={() => navigate(-1)}
            className="px-5 py-2 rounded-full font-bold text-black bg-lime-400 hover:bg-lime-500 transition"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const resolvedMedia = getBestMedia(currentEpisode?.media);
  const currentVideoUrl = resolvedMedia?.url
    ? getFullUrl(resolvedMedia.url)
    : null;
  const currentThumbnail = resolvedMedia?.thumbnailUrl
    ? getFullUrl(resolvedMedia.thumbnailUrl)
    : currentEpisode?.img
    ? `${MEDIA_BASE_URL}/uploads/workout/${currentEpisode.img}`
    : null;

  return (
    <div
      className="bg-white text-gray-800 "
      style={{ fontFamily: "'Segoe UI', sans-serif" }}
    >
      {/* ── Back Button (mobile only, shown above layout) ── */}
      <div className="flex items-center gap-3 px-4 pt-4 pb-2 lg:hidden">
        <button
          onClick={() => navigate("/dashboard")}
          className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors"
          aria-label="Go back"
        >
          <ArrowLeft className="w-5 h-5 text-gray-700" />
        </button>
        <span className="text-gray-800 font-semibold text-base truncate">
          {workout.title || "Workout"}
        </span>
      </div>

      {/* ── YouTube-style Two-Column Layout ── */}
      <div className="flex flex-col lg:flex-row lg:gap-6 lg:px-6 lg:pt-4 lg:pb-10">

        {/* ── LEFT: Video + Info ── */}
        <div className="flex-1 min-w-0">

          {/* Back button desktop */}
          <button
            onClick={() => navigate("/dashboard")}
            className="hidden lg:flex items-center gap-2 mb-3 text-gray-500 hover:text-gray-800 transition-colors text-sm font-medium"
            aria-label="Go back"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>

          {/* Video Player */}
          <div
            className="relative w-full bg-black rounded-none lg:rounded-2xl overflow-hidden"
            style={{ paddingTop: "56.25%" }}
          >
            {!isPlaying ? (
              <>
                {currentThumbnail ? (
                  <img
                    src={currentThumbnail}
                    alt={workout.title || categoryId}
                    className="absolute inset-0 w-full h-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                    }}
                  />
                ) : (
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                    <span className="text-gray-500 text-sm">No preview</span>
                  </div>
                )}

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center z-10">
                  <button
                    onClick={handlePlayNow}
                    className="w-16 h-16 rounded-full flex items-center justify-center bg-black/60 backdrop-blur-sm border border-white/30 shadow-xl transition-transform active:scale-95 hover:scale-110"
                    aria-label="Play video"
                  >
                    <Play className="w-7 h-7 text-white fill-white ml-1" />
                  </button>
                </div>

                {/* Duration Icon */}
                <div className="absolute bottom-4 right-4 z-10 w-11 h-11 rounded-xl bg-white/90 shadow-lg flex items-center justify-center">
                  <Clock className="w-5 h-5 text-gray-600" />
                </div>
              </>
            ) : (
              <div className="absolute inset-0 bg-black flex items-center justify-center">
                <video
                  ref={videoRef}
                  controls
                  className="w-full h-full object-contain"
                  poster={currentThumbnail || undefined}
                  onEnded={handleVideoEnded}
                  onTimeUpdate={handleVideoTimeUpdate}
                  onPlay={() => {
                    if (!videoStartTime) setVideoStartTime(Date.now());
                  }}
                  key={currentVideoUrl}
                >
                  <source src={currentVideoUrl} type="application/x-mpegURL" />
                  {currentVideoUrl?.endsWith(".m3u8") && (
                    <source
                      src={currentVideoUrl.replace(".m3u8", ".mp4")}
                      type="video/mp4"
                    />
                  )}
                </video>
                <button
                  onClick={handleCloseVideo}
                  className="absolute top-3 left-3 z-20 w-9 h-9 rounded-full bg-black/60 flex items-center justify-center hover:bg-black/80 transition-colors"
                  aria-label="Close video"
                >
                  <X className="w-4 h-4 text-white" />
                </button>
              </div>
            )}
          </div>

          {/* Play Now Button */}
          {!isPlaying && !isVideoEnded && (
            <div className="px-5 lg:px-0 pt-4 pb-2">
              <button
                onClick={handlePlayNow}
                className="flex items-center gap-2 px-6 py-3 rounded-full font-bold text-black text-base shadow-md transition-transform active:scale-95 hover:brightness-105 bg-lime-400"
              >
                Play Now
                <span className="w-7 h-7 rounded-full border-2 border-black flex items-center justify-center">
                  <svg className="w-4 h-4 ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
              </button>
            </div>
          )}

          {/* Workout title (desktop) */}
          <div className="hidden lg:block px-0 pt-2 pb-4">
            <h1 className="text-gray-900 text-xl font-bold">
              {currentEpisode?.title || workout.title || "Workout"}
            </h1>
            {currentEpisode?.sequence && (
              <p className="text-gray-500 text-sm mt-1">Episode {currentEpisode.sequence}</p>
            )}
          </div>
        </div>

        {/* ── RIGHT: Episodes Sidebar ── */}
        <div className="w-full lg:w-[360px] xl:w-[400px] flex-shrink-0 px-5 lg:px-0 pt-4 lg:pt-0 pb-10 mb-16 lg:mb-0">
          <h2 className="text-gray-800 text-lg font-bold mb-3">Episodes</h2>

          {/* Scrollable on desktop */}
          <div
            className="flex flex-col gap-2 lg:overflow-y-auto lg:pr-1"
            style={{ maxHeight: "calc(100vh - 120px)" }}
          >
            {episodes.map((episode, idx) => {
              const epMedia = getBestMedia(episode?.media);
              const epThumbnail = epMedia?.thumbnailUrl
                ? getFullUrl(epMedia.thumbnailUrl)
                : episode?.img
                ? `${MEDIA_BASE_URL}/uploads/workout/${episode.img}`
                : null;
              const isCurrentRoute =
                (episode._id === id && !activeEpisode) ||
                activeEpisode?._id === episode._id;
              const epTitle =
                episode.title || epMedia?.originalName || `Episode ${idx + 1}`;
              const epIsPreviewOnly =
                !hasActiveSubscription() && epMedia?.isFree === false;

              return (
                <div
                  key={episode._id}
                  onClick={() => {
                    navigate(`/workout/${episode._id}`, { replace: true });
                    handleEpisodePlay(episode);
                  }}
                  className={`flex items-center gap-3 rounded-xl p-2.5 cursor-pointer transition-all ${
                    isCurrentRoute
                      ? "bg-lime-50 border border-lime-300"
                      : "bg-gray-50 border border-gray-100 hover:bg-gray-100"
                  }`}
                >
                  {/* Thumbnail */}
                  <div className="relative w-24 h-14 rounded-lg overflow-hidden flex-shrink-0 bg-gray-200">
                    {epThumbnail ? (
                      <img
                        src={epThumbnail}
                        alt={epTitle}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.style.display = "none";
                        }}
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                        <Play className="w-5 h-5 text-gray-400" />
                      </div>
                    )}

                    {/* Lock overlay for locked episodes */}
                    {epIsPreviewOnly && (
                      <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                        <Lock className="w-4 h-4 text-white" />
                      </div>
                    )}

                    {/* Active indicator */}
                    {isCurrentRoute && (
                      <div className="absolute inset-0 flex items-center justify-center bg-black/20">
                        <div className="w-6 h-6 rounded-full bg-lime-400 flex items-center justify-center">
                          <Play className="w-3 h-3 text-black fill-black ml-0.5" />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <p className="text-gray-800 text-sm font-semibold leading-tight line-clamp-2">
                      {epTitle}
                    </p>
                    {episode.sequence && (
                      <p className="text-gray-400 text-xs mt-1">
                        Episode {episode.sequence}
                      </p>
                    )}
                    {epIsPreviewOnly && (
                      <span className="inline-block mt-1 text-xs text-amber-600 font-medium bg-amber-50 px-1.5 py-0.5 rounded-full">
                        Preview only
                      </span>
                    )}
                  </div>

                  {/* Play button */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/workout/${episode._id}`, { replace: true });
                      handleEpisodePlay(episode);
                    }}
                    className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 shadow transition-transform active:scale-90 hover:brightness-105 ${
                      isCurrentRoute ? "bg-lime-500" : "bg-lime-400"
                    }`}
                    aria-label={`Play ${epTitle}`}
                  >
                    <Play className="w-3.5 h-3.5 text-black ml-0.5 fill-black" />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutDetail;